import request from "root/js/request";

export const getWBDynamicProductsGrouped = async ({
  product_ids,
  date_from,
  date_to,
  limit,
  offset,
  ordering,
  extra_fields = "id",
  period,
  ...rest
}) => {
  const response = await request({
    url: `/wb_dynamic/products/grouped/`,
    method: "get",
    params: {
      product_ids,
      period,
      date_from,
      date_to,
      limit,
      offset,
      ordering,
      extra_fields,
      ...rest,
    },
  });
  return response.data;
};
